export default function formatNumber(number, round) {
	let roundedNumber = parseFloat(number).toFixed(round);
	let numberString = roundedNumber.toString();
	let [integerPart, decimalPart] = numberString.split('.');
	integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

	return `${integerPart},${decimalPart}`;
}
